import React, { Dispatch } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveCategory, setSidebarOpen } from '../../../../redux/vulnerabilities/sliceVulnerabilities';
import { IAppReduxStore } from '../../../../redux/store';
import Sidebar, { ISidebarAllDataBtnProps } from '../../../General/Sidebar/Sidebar';
import VulnerabilityTree from './VulnerabilityTree';

/**
 * Collapsable sidebar that shows the user the category structure of their vulnerabilities.
 */
export default () => {
    /** Configure component translation. */
    const { t } = useTranslation('translations', { keyPrefix: 'vulnerabilitySelectionView' });

    /** Allows reducers on a redux slice to be called. */
    const dispatch: Dispatch<unknown> = useDispatch();

    /** Get relevant values from Redux store. */
    const isOpen = useSelector(
        (store: IAppReduxStore) => store.vulnerabilities.settings.sidebarOpen,
    );
    const activeCategory = useSelector(
        (store: IAppReduxStore) => store.vulnerabilities.settings.activeCategory,
    );

    const vulnerabilities = useSelector((store: IAppReduxStore) => store.vulnerabilities.data);

    /** Tree structure to show in the sidebar. */
    const tree = <VulnerabilityTree />;

    /** 'State slice' for controlling the sidebar's open state. */
    const openState: [boolean, (open: boolean) => void] = [
        isOpen,
        open => {
            dispatch(setSidebarOpen(open));
        },
    ];

    /** Configuration for the sidebar's "all data" button. */
    const btnConfig: ISidebarAllDataBtnProps = {
        onClick: () => dispatch(setActiveCategory('All')),
        active: activeCategory == 'All',
        title: t('allVulnerabilities'),
    };

    if (!vulnerabilities?.length) {
        return <></>;
    }

    return <Sidebar {...{ tree, openState, btnConfig }} />;
};
